import React from 'react';
// import axios from 'axios';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { gaWrapper } from 'helpers/analytics';
import { inViewForReact } from 'utils/common';
// import throttle from 'lodash.throttle';
import Link from 'components/Link';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import CardV4 from 'components_v2/common/CardV4';
import CardV5 from 'components_v2/common/CardV5';
import FlipAnimator from 'components_v2/common/FlipAnimator';
// import ImageV2 from 'components_v2/common/ImageV2';
import AdCaller from 'helpers/ads/adCaller';
//import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import RenderAds from '../../../components/desktop/RenderAds';
import LiveblogInsert from '../../../components/mobile/LiveblogInsert';
import BudgetLinkout from './BudgetLinkout';
import s from './BudgetNewHPWidget.scss';
// import { IMAGE_URL } from '../../../../../constants';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

// const defaultSkew = 500;
class BudgetNewHPWidget extends React.Component {
  constructor() {
    super();
    this.ref = React.createRef();
    this.gaFired = false;
    this.ga4Type = 'budget_hp_widget';
    this.state = {
      isWrapperEnabled: false,
    };
  }

  componentDidMount() {
    // this.throttledInView = throttle(this.checkDomIsInView.bind(this), 10);
    this.sendGAEvent();

    if (window?._dfpObj?.adsCallEvent) {
      window._dfpObj.adsCallEvent('rajFrontAd', () => {
        this.setState({ isWrapperEnabled: true });
      });
    }
    // window.addEventListener('scroll', this.throttledInView);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledInView);
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  checkDomIsInView() {
    if (
      this.ref &&
      this.ref.current &&
      inViewForReact(this.ref.current, 0, true)
    ) {
      this.sendGAEvent();
    }
  }

  sendGAEvent = () => {
    if (!this.gaFired) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: this.ga4Type,
      });
      this.gaFired = true;
    }
  };

  renderBudgetDownload(link, heading) {
    return (
      <button
        className={`${s.buttonlinks}`}
        onClick={() => this.startBudgetDownload(link)}
      >
        {heading}
      </button>
    );
  }

  renderBudgetAds = fliper => (
    <FlipAnimator>
      <div className={s.imageText}>
        {/* <ImageV2 src={`${IMAGE_URL}msid-${fliper.frontImage}.cms`} /> */}
        <AdCaller data={{ jname: 'rajFrontAd', skipLazy: 1 }} />
        {fliper?.frontTitle && <span>{fliper.frontTitle}</span>}
      </div>
      <div className={s.imageText}>
        {/* <ImageV2 src={`${IMAGE_URL}msid-${fliper.backImage}.cms`} /> */}
        <AdCaller data={{ jname: 'rajBackAd', skipLazy: 1 }} />
        {fliper?.backTitle && <span>{fliper.backTitle}</span>}
      </div>
    </FlipAnimator>
  );

  startBudgetDownload = link => {
    window.open(link);
    gaWrapper(
      'send',
      'event',
      'Budget Widget',
      `Download`,
      `Budget Full Speech`,
    );
  };

  sliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk);
    }
    return res;
  };

  renderLiveblogList = lbgList =>
    Array.isArray(lbgList) && lbgList.length ? (
      lbgList.map(item => (
        <CardV5
          data={item}
          datanewga="BudgetWidget-Actions"
          ga4Type={this.ga4Type}
        />
      ))
    ) : (
      <CardV5
        data={lbgList}
        datanewga="BudgetWidget-Actions"
        ga4Type={this.ga4Type}
      />
    );

  render() {
    const { data, isWapView } = this.props;
    const isPrime = true;
    const cardcount = !isPrime ? 1 : 2;
    const settings = {
      slidesToShow: cardcount,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: true,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      draggable: false,
      infinite: false,
    };

    if (
      typeof data !== 'undefined' &&
      !data.budgetdata &&
      !data.budgetdata.budgetlbglead &&
      !data.budgetdata.budgetlbglead.item
    ) {
      return null;
    }
    const leadData = data.budgetdata.budgetlbglead.item;
    const { dataUrl } = data.budgetdata.budgetlbglead;
    if (isWapView) leadData.dataUrl = dataUrl;
    if (isWapView) leadData.type = 'lbgfeatured';
    leadData.tn = 'news';
    let lbgList =
      data.budgetdata.budgetlbglist &&
      data.budgetdata.budgetlbglist.items &&
      Array.isArray(data.budgetdata.budgetlbglist.items) &&
      data.budgetdata.budgetlbglist.items.length
        ? data.budgetdata.budgetlbglist.items
        : undefined;

    const lbgListType =
      data.budgetdata.budgetlbglist &&
      data.budgetdata.budgetlbglist &&
      data.budgetdata.budgetlbglist.type;
    if (
      !isWapView &&
      lbgListType === 'two_card_list' &&
      lbgList &&
      lbgList.length
    ) {
      lbgList = this.sliceIntoChunks(lbgList, 2);
    }

    if (typeof leadData === 'undefined' || (leadData && leadData.length < 1)) {
      return null;
    }
    const { linkout, fliper } = data.budgetdata;
    // const shareImage = `https://static.toiimg.com/photo/${
    //   leadData.imageid ? leadData.imageid : '47529300'
    // }.cms`;

    const datanewga = 'BudgetWidget-Actions';

    return (
      <>
        {isWapView ? (
          <div className={s.widgetContainer} ref={this.ref}>
            {/* <div className={s.head}>
              <div className={s.topRow}>
                <Link
                  to={leadData.wu}
                  target="_blank"
                  data-newga={`${datanewga}#${leadData.wu}`}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: this.ga4Type,
                      category: 'story_click',
                      msid: data?.id,
                    },
                  ]}
                >
                  <div className={s.liveBtn}>BUDGET LIVE</div>
                </Link>
                {leadData.logioimageid && (
                  <>
                    <span>/</span>
                    <Link
                      to={leadData.logoUrl ? leadData.logoUrl : leadData.wu}
                      target="_blank"
                      data-newga={`${datanewga}#${
                        leadData.logoUrl ? leadData.logoUrl : leadData.wu
                      }`}
                      ga4Data={[
                        {
                          event: 'user_click',
                          type: this.ga4Type,
                          label: leadData?.logoUrl || leadData?.wu,
                        },
                      ]}
                    >
                      <img
                        src={`https://static.toiimg.com/photo/${
                          leadData.logioimageid
                        }.cms`}
                        alt=""
                      />
                    </Link>
                  </>
                )}
              </div>
            </div> */}
            <div className={s.blogWrap}>
              {leadData && (
                <LiveblogInsert
                  sectionData={leadData}
                  isWapView={isWapView}
                  datanewga={datanewga}
                  isBudget
                  ga4Type={this.ga4Type}
                />
              )}
              {fliper?.tn === 'crest' &&
                (!this.props.isPrime ||
                  (fliper?.primeDisabled && fliper?.primeDisabled !== '1')) && (
                  <div
                    className={this.state.isWrapperEnabled ? s.flipWrap : ''}
                  >
                    {fliper?.link ? (
                      <Link to={fliper?.link}>
                        {this.renderBudgetAds(fliper)}
                      </Link>
                    ) : (
                      this.renderBudgetAds(fliper)
                    )}
                  </div>
                )}
              <div className={s.otherBlogWrap}>
                {/* <h4>Other Live Blogs</h4> */}
                {Array.isArray(lbgList) &&
                  lbgList.length && (
                    <div className={s.mSlider}>
                      {lbgList.map(lblist => (
                        <div className={s.cardBox}>
                          {this.renderLiveblogList(lblist)}
                        </div>
                      ))}
                    </div>
                  )}
              </div>
              <div className="linkouts">
                {linkout?.tn === 'linkoutslider' && (
                  <BudgetLinkout
                    data={linkout}
                    isWapView={isWapView}
                    cardcount={3.1}
                    datanewga={datanewga}
                    ga4Type={this.ga4Type}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            ref={this.ref}
            className={`
            ${this.props.wrapperclass ? s[this.props.wrapperclass] : ''}
          ${s.supperWrap}`}
          >
            <section
              className={`
                ${s.budgetWrap}
                ${!isPrime ? s.budgetWrapNoPrime : ''}
              `}
            >
              <article>
                <CardV4
                  data={leadData}
                  datanewga={datanewga}
                  ga4Type={this.ga4Type}
                />
              </article>
              {Array.isArray(lbgList) &&
                lbgList.length && (
                  <div className={`${s.rightWrap} slick_UI`}>
                    {!isPrime ? (
                      <Slider {...settings}>
                        {lbgList.map(lblist => (
                          <div className={s.cardBox}>
                            {this.renderLiveblogList(lblist)}
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      lbgList.map(lblist => (
                        <div className={s.cardBox}>
                          {this.renderLiveblogList(lblist)}
                        </div>
                      ))
                    )}
                  </div>
                )}
              {/* ad container no prime user */}
              {!this.props.isWapView &&
                !isPrime && (
                  <RenderAds
                    adObject={data?.budgetdata?.budgethomeadcode}
                    key={data?.budgetdata?.budgethomeadcode?.key}
                  />
                )}
            </section>
            <div
              className={`${s.linkouts} ${
                fliper?.tn === 'crest' &&
                this.state.isWrapperEnabled &&
                (!this.props.isPrime ||
                  (fliper?.primeDisabled && fliper?.primeDisabled !== '1'))
                  ? s.flipVisible
                  : ''
              }`}
            >
              {fliper?.tn === 'crest' &&
                (!this.props.isPrime ||
                  (fliper?.primeDisabled && fliper?.primeDisabled !== '1')) && (
                  <div
                    className={this.state.isWrapperEnabled ? s.flipWrap : ''}
                  >
                    {fliper?.link ? (
                      <Link to={fliper?.link}>
                        {this.renderBudgetAds(fliper)}
                      </Link>
                    ) : (
                      this.renderBudgetAds(fliper)
                    )}
                  </div>
                )}
              {linkout?.tn === 'linkoutslider' && (
                <BudgetLinkout
                  data={linkout}
                  isWapView
                  cardcount={6}
                  datanewga={datanewga}
                  ga4Type={this.ga4Type}
                />
              )}
            </div>
            <InterSectionBorder />
          </div>
        )}
      </>
    );
  }
}

BudgetNewHPWidget.propTypes = {
  isWapView: PropTypes.bool,
  isPrime: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
    data: PropTypes.shape({}),
    refreshUrl: PropTypes.string,
    path: PropTypes.string,
  }),
  wrapperclass: PropTypes.string,
  // skew: PropTypes.string,
};
BudgetNewHPWidget.defaultProps = {
  isWapView: false,
  isPrime: false,
  data: {},
  wrapperclass: '',
  // skew: undefined,
};

export default BudgetNewHPWidget;
